import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
// import { TranslateModule } from '@ngx-translate/core';
// import { DirectivesModule } from './directives/directives.module';
import { ComponentsModule } from "./components/components.module";
import { ShellModule } from "./shell/shell.module";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "./pipe/pipe.module";

const modules: any[] = [
  PipesModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  //   DirectivesModule,
  ShellModule,
  ComponentsModule,
];

@NgModule({
  declarations: [],
  imports: [...modules],
  exports: [...modules],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
